<template>
  <fragment>
    <div class="card-on-card card-outline-secondary">
      <div class="card-header">
        <h5 class="mb-2 font-weight-bold"><b> Status</b></h5>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-8">
            <div class="form-row mb-4">
              <label class="col-md col-form-label" for="name">Status</label>
              <div class="col-lg-8">
                <select
                  class="form-control custom-select"
                  name="nonBookActiveStatus"
                  id="nonBookActiveStatus"
                >
                  <option value="1">Enable (Aktif)</option>
                  <option value="0">Disable (Tidak Aktif)</option>
                </select>
                <p class="text-muted small">
                  Gunakan tanda '.' untuk menuliskan koma (misal: 0.200)
                </p>
                <span class="help-block with-errors"></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </fragment>
</template>

<script>
// import axios from "axios";
import $ from "jquery";

export default {
  data() {
    return {
      stock: 0,
    };
  },
  watch: {
    stock() {
      if (this.stock === null) {
        $(".invalidStock").text(`Stok tidak boleh kosong`);
        $("#nonBookStock").addClass("is-invalid");
      } else {
        $("#nonBookStock").removeClass("is-invalid");
      }
    },
  },
};
</script>